
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/firms/lpl",
      function () {
        return require("private-next-pages/firms/lpl.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/firms/lpl"])
      });
    }
  